let token: string | null = null;

export const pendingMfa = {
  get: () => token,
  set: (next: string | null) => {
    token = next;
  },
};
